export type UiTheme = 'light' | 'dark' | 'system';
export type ApiTheme = 'LIGHT' | 'DARK' | 'AUTOMATIC';

const API_TO_UI: Record<ApiTheme, UiTheme> = {
  LIGHT: 'light',
  DARK: 'dark',
  AUTOMATIC: 'system',
};

const UI_TO_API: Record<UiTheme, ApiTheme> = {
  light: 'LIGHT',
  dark: 'DARK',
  system: 'AUTOMATIC',
};

export function themeFromApi(value: string | null | undefined): UiTheme | null {
  if (!value) return null;
  return (API_TO_UI as Record<string, UiTheme | undefined>)[value] ?? null;
}

export function themeToApi(theme: UiTheme): ApiTheme {
  return UI_TO_API[theme];
}
